import React, { useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';

import { useStaticQuery, graphql, Link } from 'gatsby';

import Image from '../image';

import Tag from '../../tag';

import { withSlider } from '../../context/SliderContext';

SwiperCore.use([Navigation]);

import 'swiper/swiper-bundle.min.css';
import sliderStyles from './slider.module.css';

type Recipe = {
  pid: string;
  rid: string;
  slug: string;
  sticker?: string;
  tag: string;
  title: string;
};

// type Props = {
//   slide: number;
// };

function Slider() {
  const { allRecipe } = useStaticQuery(graphql`
    query {
      allRecipe {
        nodes {
          pid
          rid
          slug
          sticker
          tag
          title
        }
      }
    }
  `);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const tag = event.currentTarget.getAttribute('data-tag');
    if (tag) {
      Tag.send(null, tag);
    }
  };

  return (
    <Swiper
      centeredSlides
      initialSlide={2}
      spaceBetween={20}
      slidesPerView={1.5}
      loop
      navigation
      allowTouchMove={ typeof window !== 'undefined' ? window.matchMedia( '(hover: none)' ).matches : false}
      breakpoints={{
        768: {
          slidesPerView: 2,
          centeredSlides: false,
          initialSlide: 1
        },
        1024: {
          slidesPerView: 3,
          centeredSlides: false,
          initialSlide: 1
        },
        1280: {
          slidesPerView: 4,
          centeredSlides: false,
          initialSlide: 0
        },
        1600: {
          slidesPerView: 5,
          centeredSlides: false,
          initialSlide: 0
        },
      }}
    >
      {allRecipe.nodes.map((recipe: Recipe, index: number) => {
        return (
          <SwiperSlide className={`slide-${recipe.rid}`} key={index}>
            <Link
              to={recipe.slug}
              onClick={handleClick}
              data-tag={`Recette-${recipe.tag}`}
              title={`Voir la recette ${recipe.title}`}
            >
              <Image
                alt={recipe.title}
                className={`recipe-slider-image ${sliderStyles.image}`}
                path={`recipe-${recipe.pid}.jpg`}
              />
              {recipe.sticker && (
                <Image
                  alt="miam"
                  className={`sticker ${sliderStyles.sticker}`}
                  path={recipe.sticker}
                />
              )}
            </Link>
          </SwiperSlide>
        );
      })}
      <SwiperSlide className={`slide-tips`} key={allRecipe.nodes.length + 1}>
        <Link to="lexique/" onClick={handleClick} data-tag="Lexique" title="Voir le lexique">
          <Image alt="Le dictionnaire culinaire" className={sliderStyles.image} path={`tips.jpg`} />
          <Image
            alt="Le dico culinaire"
            className={`sticker ${sliderStyles.sticker}`}
            path="tips-sticker.png"
          />
        </Link>
      </SwiperSlide>
    </Swiper>
  );
}

export default withSlider(Slider);
